import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: "https://skishore.in/api",
  withCredentials: true, // 🔥 REQUIRED FOR COOKIE
});

// ✅ Attach token from localStorage for Mac / cross-origin environments where cookies might be blocked
axiosInstance.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("auth_token") ||
      localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
